/**
 * マーカーポップアップのHTML、詳細パネルのHTMLを生成する
 */
export default class PopupFactory {
  constructor(options) {
    this.options = options;
    this.templateClass = 'info-window-template';
    this.templateQuery = '.' + this.templateClass;
    this.popupClass = 'info-window';
  }
  /**
   * マーカーが表示するポップアップを生成する
   *
   * @param {Place} jm
   * @returns DOMElement
   */
  build(jm) {
    if (jm.type === 999){
      return;
    }

    var tpl = $(this.templateQuery).clone();
    tpl.removeClass(this.templateClass).addClass(this.popupClass);

    this.fillMarkerPopup(jm, tpl);

    tpl.show();
    return tpl.get(0);
  }
  /**
   * DOMに施設情報を埋め込む
   * TODO: 行の表示切り替えなんとかならんか
   *
   * @param {Object} place
   * @param {jQuery} popup
   * @returns {undefined}
   */
  fillMarkerPopup(place, popup){
    popup.find('.iw-name').text(place.name);
    popup.find('.iw-type').text(this.options.placeType.getName(place.type));
  
    // if(parseInt(place.type, 10) < 1000){
    //   popup.find('.iw-name').closest('.iw-item').show();
    //   popup.find('.iw-facility-name').closest('.iw-item').hide();
    // } else {
    //   popup.find('.iw-facility-name').text(place.name);
    //   popup.find('.iw-facility-name').closest('.iw-item').show();
    //   popup.find('.iw-name').closest('.iw-item').hide();
    // }
    //
    // if(parseInt(place.type, 10) < 1000){
    //   //popup.find('.iw-type').text(place.attributes['綱']);
    //   popup.find('.iw-type').closest('.iw-item').show();
    // } else {
    //   popup.find('.iw-type').text(place.area);
    //   popup.find('.iw-type').closest('.iw-item').hide();
    // }

    if (place.area && typeof place.area !== 'undefined'){
      popup.find('.iw-area').text(place.area);
      popup.find('.iw-area').closest('.iw-item').show();
    }else{
      popup.find('.iw-area').closest('.iw-item').hide();
    }

    if (place.address && typeof place.address !== 'undefined'){
      popup.find('.iw-address').text(place.address);
      popup.find('.iw-address').closest('.iw-item').show();
    }else{
      popup.find('.iw-address').closest('.iw-item').hide();
    }

    // 距離
    if (place.distance && typeof place.distance !== 'undefined'){
      popup.find('.iw-distance').text(place.distance + "m");
      popup.find('.iw-distance').closest('.iw-item').show();
    }else{
      popup.find('.iw-distance').closest('.iw-item').hide();
    }

    if (place.tel && typeof place.tel !== 'undefined'){
      popup.find('.iw-tel a').text(place.tel).attr('href', "tel:" + place.tel);
      popup.find('.iw-tel').closest('.iw-item').show();
    }else{
      popup.find('.iw-tel').closest('.iw-item').hide();
    }

    // console.log(this.parseUrl('やお  http://yao.com | ほげ http://hogehoge.com/'));
    // console.log(this.parseUrl('http://example.com/'));

    // Todo 処理検討 by k.sonoda
    if (place.url && typeof place.url !== 'undefined'){
      const IH = require('./z.core');
      let urls = IH.parseUrl(place.url);
      let tpl = popup.find('.iw-url a').not('.real-link');
      IH.fillUrls(urls, tpl);
      popup.find('.iw-url').closest('.iw-item').show();
    }else{
      popup.find('.iw-url').closest('.iw-item').hide();
    }
    if (place.url2 && typeof place.url2 !== 'undefined'){
      let urls2 = this.parseUrl(place.url2);
      let tpl2 = popup.find('.iw-url2 a').not('.real-link');
      this.fillUrls(urls2, tpl2);
      popup.find('.iw-url2').closest('.iw-item').show();
    }else{
      popup.find('.iw-url2').closest('.iw-item').hide();
    }

    if (place.image && typeof place.image !== 'undefined'){
      var path = place.image;
  
      // 複数の画像パスを '|' で分割
      path = path.split('|');
      
      // 画像パスを整形
      for(var i = 0; i < path.length; i++){
        
        // 改行や空白を削除
        path[i] = path[i].replace(/[\n\r\s]/g, '');
  
        // 画像パスがURLでなければ、ローカルパスを追加
        if (!path[i].match(/^http/)){
          path[i] = this.options.place_image_path + path[i];
        }
        
      }
      
      // if (!place.image.match(/^http/)){
      //   path = this.options.place_image_path + place.image;
      // }
      
      // 画像が複数ある場合は1枚目だけ表示
      popup.find('.iw-image').attr('src', path[0]);
      //popup.find('.iw-image').attr('src', path);
      
      popup.find('.iw-image').closest('.iw-item').show();
    }else{
      popup.find('.iw-image').closest('.iw-item').hide();
    }

    if ('icon_min' in place) {
      popup.find('.iw-type-icon').attr('src', place.icon_min);
    } else {
      popup.find('.iw-type-icon').attr('src', this.options.placeType.getTypeIcon(place.type));
    }

    if (place.description && typeof place.description !== 'undefined'){
      popup.find('.iw-description').html(place.description);
      popup.find('.iw-description').closest('.iw-item').show();
    }else{
      popup.find('.iw-description').closest('.iw-item').hide();
    }

    if (place.info && typeof place.info !== 'undefined'){
      popup.find('.iw-info').html(place.info);
      popup.find('.iw-info').closest('.iw-item').show();
    }else{
      popup.find('.iw-info').closest('.iw-item').hide();
    }
    // 色分けのため、タイプを追加
    // TODO:パネルでは再利用するため使えない
    // popup.addClass('place' + place.type);
  
    // ストリートビューのサムネイル・リンク
    if (place.sv_heading && typeof place.sv_heading !== 'undefined') {
    
      let lat = place.sv_lat || place.lat;
      let lng = place.sv_lng || place.lng;
    
      if (lat && lng) {
      
        let param = {
          size: '180x80',
          sensor: false
        };
        param.heading = place.sv_heading;
        param.fov = place.sv_fov;
        param.pitch = place.sv_pitch;
        param.location = lat + ',' + lng;
        param.key = this.options.streetviewAPIKey;
      
        let url = 'https://maps.googleapis.com/maps/api/streetview?' + jQuery.param(param);
  
        popup.find('.iw-sv').show();
        popup.find('.iw-sv').on('click', function(event){
        
          // ストリートビューに切り替え
          let panorama = that.map.getMap().getStreetView();
          panorama.setVisible(true);
          panorama.setPosition(new google.maps.LatLng(lat, lng));
          panorama.setPov({
            heading: parseInt(param.heading),
            pitch: parseInt(param.pitch)
          });
        
          event.stopPropagation();
        
          return false;
        
        });
  
        popup.find('.iw-sv img').attr('src', url);
      
      }　else　{
        popup.find('.iw-sv').hide();
      }
    }　else　{
      popup.find('.iw-sv').hide();
    }

    popup.data('place-id', place.id)
    
    this.options.mapEvents.emit('ihFillMarkerPopup', place, popup);
  }
}




// WEBPACK FOOTER //
// ./map/js/ih/PopupFactory.js